import useAuthentication from "../../../hooks/useAuthentication";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../../../shared/components/card/Card";
import { Button } from "../../../shared/components/button/Button";
import { useNavigate } from "react-router";
import {
  PERMISSIONS_CONTROLCENTRE,
  PERMISSIONS_DATAAPI,
  ROLES,
  USERS,
} from "../../../shared/lib/routesResolver";
import BreadcrumbPanel from "../../../shared/components/breadcrumb/BreadcrumbPanel";

const HomeContainer = () => {
  const auth = useAuthentication();
  const navigate = useNavigate();

  const HomeCard = ({ title, content, link }) => (
    <Card className="w-full md:w-1/4">
      <CardHeader>
        <CardTitle>{title}</CardTitle>
      </CardHeader>
      <CardContent>{content}</CardContent>
      <CardFooter>
        <Button className="w-full" onClick={() => navigate(link)}>
          Ir al menú
        </Button>
      </CardFooter>
    </Card>
  );

  return (
    <>
      <div className="px-4 pb-4 sm:px-6">
        <BreadcrumbPanel items={[]} />
      </div>
      <div className="flex flex-col gap-y-10">
        <div className="text-3xl font-normal md:leading-4 p-4">
          ¡Bienvenido al AdQuiver Security Centre,{" "}
          <b>{auth.userLogged().fullname}</b>!
        </div>
        <div className="p-4 flex flex-col md:flex-row justify-between gap-y-4 md:gap-x-4">
          <HomeCard
            title="Usuarios"
            content="Menú de administración de los usuarios de las apps de AdQuiver"
            link={USERS}
          />
          <HomeCard
            title="Roles"
            content="Menú de administración de los roles asociados a los usuarios de las apps de AdQuiver."
            link={ROLES}
          />
          <HomeCard
            title="Permisos Data API"
            content="Menú de administración de los permisos asociados a los roles de Data API."
            link={PERMISSIONS_DATAAPI}
          />
          <HomeCard
            title="Permisos Control Centre"
            content="Menú de administración de los permisos asociados a los roles de Control Centre."
            link={PERMISSIONS_CONTROLCENTRE}
          />
        </div>
      </div>
    </>
  );
};

export default HomeContainer;
